

// // ewhithout redux 

// import React, { useEffect, useState } from "react";
// import { Card, Spin, message, Tooltip, Badge, Empty } from "antd";
// import { TrophyOutlined } from "@ant-design/icons";
// import courseService from "../../services/course.service";

// const NoteFinaleViewer = ({ courseId }) => {
//   const [noteData, setNoteData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // ✅ Récupération de l'utilisateur depuis le localStorage
//   const storedUser = JSON.parse(localStorage.getItem("user"));
//   const userId = storedUser?.id;

//   useEffect(() => {
//     const fetchData = async () => {
//   if (!courseId || !userId) return;
//   setLoading(true);

//   try {
//     const notes = await courseService.CalculeNoteFinale(courseId, userId);
//     console.log("note finale API:", JSON.stringify(notes));

//     if (!notes || notes.length === 0 || notes[0].noteEvaluation === null || notes[0].noteEvaluation === 0) {
//       setNoteData(null);
//     } else {
//       setNoteData(notes[0]);
//     }
//   } catch (err) {
//     console.error("Erreur lors de la récupération de la note finale :", err);
//     message.error("Impossible de récupérer la note finale");
//   } finally {
//     setLoading(false);
//   }
// };


//     fetchData();
//   }, [courseId, userId]);

//   // ✅ Condition globale : pas de rendu si aucune note valide
//   if (!noteData) {
//     return null;
//   }

//   return (
//     <div
//       style={{
//         position: "absolute",
//         top: "10px",
//         right: "30px",
//         zIndex: 10,
//       }}
//     >
//       <Spin spinning={loading}>
//         <Tooltip title="Votre note finale pour ce cours">
//           <Badge.Ribbon text="Note finale" color="gold">
//             <Card
//               style={{
//                 width: 180,
//                 textAlign: "center",
//                 background: "#fff8e1",
//                 border: "1px solid #ffd666",
//                 boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//                 borderRadius: "10px",
//                 cursor: "pointer",
//               }}
//             >
//               <TrophyOutlined style={{ fontSize: 28, color: "#faad14" }} />
//               <h3 style={{ margin: "8px 0", color: "#333" }}>Note</h3>
//               <div
//                 style={{
//                   fontSize: "22px",
//                   fontWeight: "bold",
//                   color: noteData.noteFinale >= 70 ? "#52c41a" : "#ff4d4f",
//                 }}
//               >
//                 {noteData.noteFinale.toFixed(2)} / 100
//               </div>

//             </Card>
//           </Badge.Ribbon>
//         </Tooltip>
//       </Spin>
//     </div>
//   );
// };

// export default NoteFinaleViewer;


// with redux 

import React, { useEffect } from "react";
import { Card, Spin, message, Tooltip, Badge, Empty } from "antd";
import { TrophyOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";
import { useDispatch, useSelector } from "react-redux";
import { setNoteFinale } from "../../actions/noteActions";

const NoteFinaleViewer = ({ courseId }) => {
  const dispatch = useDispatch();
  const noteData = useSelector((state) => state.note.noteData);
  const [loading, setLoading] = React.useState(false);

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.id;


  useEffect(() => {
  console.log("👀 [NoteFinaleViewer] Valeur actuelle du store:", noteData);
}, [noteData]);


  useEffect(() => {
    const fetchData = async () => {
      if (!courseId || !userId) return;
      setLoading(true);

      try {
        const notes = await courseService.CalculeNoteFinale(courseId, userId);
        console.log("note finale API:", JSON.stringify(notes));

        if (!notes || notes.length === 0 || notes[0].noteEvaluation === null || notes[0].noteEvaluation === 0) {
          dispatch(setNoteFinale(null));
        } else {
          dispatch(setNoteFinale(notes[0]));
        }
      } catch (err) {
        console.error("Erreur lors de la récupération de la note finale :", err);
        message.error("Impossible de récupérer la note finale");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [courseId, userId, dispatch]);

  if (!noteData) {
    return null;
  }

  return (
    <div style={{ position: "absolute", top: "10px", right: "30px", zIndex: 10 }}>
      <Spin spinning={loading}>
        <Tooltip title="Votre note finale pour ce cours">
          <Badge.Ribbon text="Note finale" color="gold">
            <Card
              style={{
                width: 180,
                textAlign: "center",
                background: "#fff8e1",
                border: "1px solid #ffd666",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                borderRadius: "10px",
                cursor: "pointer",
              }}
            >
              <TrophyOutlined style={{ fontSize: 28, color: "#faad14" }} />
              {/* <h3 style={{ margin: "8px 0", color: "#333" }}>Note</h3> */}
              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "bold",
                  color: noteData.noteFinale >= 70 ? "#52c41a" : "#ff4d4f",
                }}
              >
                {noteData.noteFinale.toFixed(2)} / 100
              </div>
            </Card>
          </Badge.Ribbon>
        </Tooltip>
      </Spin>
    </div>
  );
};

export default NoteFinaleViewer;
